import React from "react";
import { AlertCircle } from "lucide-react";
import _ from "lodash";

/**
 * Message Component
 * Display empty state or info messages with optional icon
 * Refactored with Tailwind CSS
 * 
 * @component
 * @param {string} message - Message text to display
 * @param {string} className - Variant class (tourPlan, query, visitDetails, marketVisit, DealerLocatorForm)
 * @param {ReactNode} icon - Optional custom icon
 */
const Message = ({ message, className, icon = "" }) => {
  const variants = {
    tourPlan__messageConatiner: "flex justify-center items-center flex-col",
    query__messageConatiner: "flex h-[calc(100vh-220px)] justify-center items-center flex-col overflow-hidden",
    visitDetails__OuterDiv: "flex justify-center items-center flex-col",
    marketVisit__icon: "flex justify-center items-center flex-col",
    DealerLocatorForm__mapAccess: "mt-12 p-4 flex justify-center items-center flex-col",
  };

  const containerClass = variants[className] || "flex justify-center items-center flex-col";

  return (
    <div className={containerClass}>
      <div className="pt-4">
        {!_.isEmpty(icon) ? (
          icon
        ) : (
          <AlertCircle className="w-8 h-8 text-gray-500" />
        )}
      </div>
      <p className="text-center mt-2 font-medium text-gray-500">
        {message}
      </p>
    </div>
  );
};

export default Message;
